/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  getOverrideProps,
  getOverridesFromVariants,
  mergeVariantsAndOverrides,
} from "@aws-amplify/ui-react/internal";
import { Flex, Text } from "@aws-amplify/ui-react";
import IconsNew from "./IconsNew";
export default function PrimaryButton(props) {
  const { overrides: overridesProp, ...rest } = props;
  const variants = [
    {
      overrides: {
        label: {},
        IconsNew: {},
        "text + icon": {},
        PrimaryButton: {},
      },
      variantValues: { property1: "enabled" },
    },
    {
      overrides: {
        label: { display: "none" },
        IconsNew: { display: "block" },
        "text + icon": {},
        PrimaryButton: { padding: "10px 15px 10px 15px" },
      },
      variantValues: { property1: "loading" },
    },
    {
      overrides: {
        label: {
          fontSize: "14px",
          fontWeight: "400",
          color: "rgba(72,103,106,1)",
          lineHeight: "21px",
          children: "Confirmation text",
        },
        IconsNew: { display: "block", property1: "check" },
        "text + icon": {},
        PrimaryButton: {
          padding: "10px 15px 10px 15px",
          backgroundColor: "rgba(224,234,235,1)",
        },
      },
      variantValues: { property1: "done" },
    },
    {
      overrides: {
        label: {},
        IconsNew: {},
        "text + icon": {},
        PrimaryButton: { backgroundColor: "rgba(91,131,134,1)" },
      },
      variantValues: { property1: "on_tap" },
    },
    {
      overrides: {
        label: {},
        IconsNew: {},
        "text + icon": {},
        PrimaryButton: { backgroundColor: "rgba(219,219,219,1)" },
      },
      variantValues: { property1: "disabled" },
    },
  ];
  const overrides = mergeVariantsAndOverrides(
    getOverridesFromVariants(variants, props),
    overridesProp || {}
  );
  return (
    <Flex
      gap="0"
      direction="row"
      width="358px"
      height="46px"
      justifyContent="center"
      alignItems="center"
      position="relative"
      border="1px SOLID rgba(0,0,0,0)"
      borderRadius="8px"
      padding="7px 15px 7px 15px"
      backgroundColor="rgba(107,154,158,1)"
      display="flex"
      {...getOverrideProps(overrides, "PrimaryButton")}
      {...rest}
    >
      <Flex
        gap="8px"
        direction="row"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="center"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        display="flex"
        {...getOverrideProps(overrides, "text + icon")}
      >
        <Text
          fontFamily="Inter"
          fontSize="20px"
          fontWeight="500"
          color="rgba(255,255,255,1)"
          lineHeight="30px"
          textAlign="left"
          display="block"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Primary"
          {...getOverrideProps(overrides, "label")}
        ></Text>
        <IconsNew
          width="24px"
          height="24px"
          display="none"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          overflow="hidden"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          property1="loading"
          {...getOverrideProps(overrides, "IconsNew")}
        ></IconsNew>
      </Flex>
    </Flex>
  );
}
